import React from 'react';
import AddEdit from '../../components/product/add_edit/Component';

const Component = () => {
  return (
      <AddEdit componentTitle="Product"/>
  )
}

export default Component
